import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import App from './app/App'
import AppProviders from './app/providers'
import './shared/styles/globals.scss'
import './styles/main.scss'
import reportWebVitals from './reportWebVitals'

const rootElement = document.getElementById('root')

const render = () => {
  const content = (
    <AppProviders>
      <App />
    </AppProviders>
  )

  if (process.env.NODE_ENV === 'production') {
    if (rootElement.dataset.prerendered === 'true') hydrateRoot(rootElement, content)
    else createRoot(rootElement).render(content)
    return
  }

  createRoot(rootElement).render(<React.StrictMode>{content}</React.StrictMode>)
}

render()

reportWebVitals()
